"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".resultContent_d9f73d58{display:table-row}.resultContent_d9f73d58 .resultItem_d9f73d58{display:table-cell;vertical-align:bottom}.peoplePickerPersona_d9f73d58{width:180px}.peoplePickerPersona_d9f73d58 .ms-Persona-details{width:100%}.peoplePicker_d9f73d58 .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_d9f73d58{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}\n" }]);
exports.resultContent = "resultContent_d9f73d58";
exports.resultItem = "resultItem_d9f73d58";
exports.peoplePickerPersona = "peoplePickerPersona_d9f73d58";
exports.peoplePicker = "peoplePicker_d9f73d58";
exports.peoplePickerPersonaContent = "peoplePickerPersonaContent_d9f73d58";
//# sourceMappingURL=PeoplePicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/pickers/PeoplePicker/PeoplePicker.scss.js
// module id = 414
// module chunks = 0